import type {DataConfig} from '@sail/data';
import {ApolloLink} from '@apollo/client';
import PossibleTypes from '../../schema/possibleTypes.json';
import anonymousTypes from '../../schema/anonymousTypes.json';
import createV2ApolloLink from './createV2ApolloLink';

const {possibleTypes} = PossibleTypes;

export default function getV2SchemaConfig(
  apolloLinks: ApolloLink[],
  endpoint: string,
): NonNullable<DataConfig['graphql']>['schemas'] {
  return {
    graphql: {
      apolloLink: ApolloLink.from([
        ...apolloLinks,
        createV2ApolloLink(endpoint),
      ]),
      possibleTypes,
      anonymousTypes,
    },
  };
}
